import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const services = [{
  id: 1,
  title: "Product Launch & Roadmap",
  description: "Expert guidance from idea to launch, including product strategy, vendor sourcing, timeline planning, and technical setup to ensure a successful market entry."
}, {
  id: 2,
  title: "Operational Efficiency Audit",
  description: "Comprehensive review of workflows, systems, and vendor relationships to identify bottlenecks and propose actionable improvements for enhanced productivity."
}, {
  id: 3,
  title: "Turnkey Vendor / Procurement Advisory",
  description: "End-to-end support for supply chain optimization, vendor selection, and contract management to reduce costs and improve reliability."
}, {
  id: 4,
  title: "Account / Relationship Management Support",
  description: "Dedicated coordination with clients, vendors, and stakeholders to prevent miscommunication, manage scope, and ensure project success."
}, {
  id: 5,
  title: "Technical / Systems Setup & Support",
  description: "Implementation and refinement of internal software tools including CRM, ticketing systems, and project management platforms for streamlined operations."
}];
export default function ComprehensiveLaunchSolutions() {
  return <section className="py-16 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 animate-fade-in-up">
          <h2 className="text-4xl font-bold text-foreground mb-4">
            Comprehensive Launch Solutions
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            From strategy to execution, Aran Group provides tailored consulting services to help your business thrive at every stage.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => <Card key={service.id} data-index={i} className="bg-white border border-border hover:-translate-y-1 hover:shadow-medium transition-all duration-[250ms] ease-[cubic-bezier(0.22,1,0.36,1)] px-6">
              <CardHeader className="px-0">
                <CardTitle className="text-xl text-primary">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="px-0">
                <CardDescription className="text-foreground/80 leading-relaxed">
                  {service.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}